import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Check, Lock } from 'lucide-react';

const STATUS_LABEL = { not_started: 'Not started', in_progress: 'In progress', complete: 'Complete' };

export const StageTabs = ({ bid, stages, statuses, current, onNavigate }) => {
  useEffect(() => {
    document.querySelector(`[data-testid="stage-tab-${current}"]`)?.scrollIntoView({ inline: 'center', block: 'nearest' });
  }, [current]);
  return (
  <nav aria-label="Blueprint stages" className="relative flex w-full max-w-full gap-2 overflow-x-auto pb-2" data-testid="stage-tabs">
    {stages.map((s) => {
      const active = s.key === current;
      const st = statuses?.[s.key] || 'not_started';
      if (!s.available) {
        return (
          <span key={s.key} className="shrink-0 inline-flex items-center gap-2 rounded-full border border-dashed border-matte/15 px-4 py-2 text-[11px] uppercase tracking-[0.16em] text-matte/40" data-testid={`stage-tab-${s.key}`}>
            <Lock size={10} /> {s.number} {s.name}
          </span>
        );
      }
      return (
        <Link key={s.key} to={`/founder/blueprint/${bid}/${s.key}`} onClick={onNavigate}
          aria-current={active ? 'step' : undefined}
          className={`shrink-0 inline-flex items-center gap-2 rounded-full px-4 py-2 text-[11px] uppercase tracking-[0.16em] transition-colors duration-200 ${active ? 'bg-matte text-ivory' : 'bg-white border border-matte/15 text-matte hover:border-matte/40'}`}
          data-testid={`stage-tab-${s.key}`} data-status={st}>
          {st === 'complete' ? <Check size={11} className="text-gold" /> : <span className="text-gold">{s.number}</span>} {s.name}
          <span className="sr-only">({STATUS_LABEL[st]})</span>
        </Link>
      );
    })}
  </nav>
  );
};

export const statusLabel = (st) => STATUS_LABEL[st] || STATUS_LABEL.not_started;
